import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bcb099f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "points-card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "points-card_coin" }, null, -1))
const _hoisted_3 = { class: "points-card_content" }
const _hoisted_4 = { class: "points-card_header" }
const _hoisted_5 = { class: "points-card_points" }
const _hoisted_6 = { class: "points-card_actions" }
const _hoisted_7 = {
  key: 0,
  class: "points-card_lockIcon"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_1915_7448)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M11.8889 6.8H12.4444C12.5918 6.8 12.7331 6.86321 12.8373 6.97574C12.9415 7.08826 13 7.24087 13 7.4V13.4C13 13.5591 12.9415 13.7117 12.8373 13.8243C12.7331 13.9368 12.5918 14 12.4444 14H3.55556C3.40821 14 3.26691 13.9368 3.16272 13.8243C3.05853 13.7117 3 13.5591 3 13.4V7.4C3 7.24087 3.05853 7.08826 3.16272 6.97574C3.26691 6.86321 3.40821 6.8 3.55556 6.8H4.11111V6.2C4.11111 5.64845 4.2117 5.1023 4.40714 4.59273C4.60257 4.08316 4.88902 3.62016 5.25014 3.23015C5.61126 2.84015 6.03996 2.53078 6.51179 2.31971C6.98361 2.10864 7.4893 2 8 2C8.5107 2 9.01639 2.10864 9.48821 2.31971C9.96004 2.53078 10.3887 2.84015 10.7499 3.23015C11.111 3.62016 11.3974 4.08316 11.5929 4.59273C11.7883 5.1023 11.8889 5.64845 11.8889 6.2V6.8ZM10.7778 6.8V6.2C10.7778 5.40435 10.4851 4.64129 9.96419 4.07868C9.44325 3.51607 8.73671 3.2 8 3.2C7.26329 3.2 6.55675 3.51607 6.03581 4.07868C5.51488 4.64129 5.22222 5.40435 5.22222 6.2V6.8H10.7778ZM7.44444 9.2V11.6H8.55556V9.2H7.44444Z",
      fill: "#0E2242"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_1915_7448" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "16",
        height: "16",
        fill: "white"
      })
    ])
  ])
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-history" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_2088_9755)" }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M7.5 1.25C10.9519 1.25 13.75 4.04812 13.75 7.5C13.75 10.9519 10.9519 13.75 7.5 13.75C4.04812 13.75 1.25 10.9519 1.25 7.5H2.5C2.5 10.2612 4.73875 12.5 7.5 12.5C10.2612 12.5 12.5 10.2612 12.5 7.5C12.5 4.73875 10.2612 2.5 7.5 2.5C5.78125 2.5 4.265 3.36687 3.36562 4.6875H5V5.9375H1.25V2.1875H2.5V3.75C3.64 2.23125 5.45562 1.25 7.5 1.25ZM8.125 4.375V7.24062L10.1519 9.2675L9.2675 10.1519L6.875 7.75812V4.375H8.125Z",
        fill: "#B03FFB"
      })
    ]),
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_2088_9755" }, [
        /*#__PURE__*/_createElementVNode("rect", {
          width: "15",
          height: "15",
          fill: "white"
        })
      ])
    ])
  ])
], -1))
const _hoisted_11 = {
  key: 0,
  class: "points-card_tip"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ac_button = _resolveComponent("ac-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('pointsPage.yourPoints')), 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.points), 1),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_ac_button, {
          class: "points-card_action button button-spend",
          disabled: _ctx.isNotEnoughPoints,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handlerClick()))
        }, {
          default: _withCtx(() => [
            (_ctx.isNotEnoughPoints)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('pointsPage.spendPoints')), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_ac_button, {
          onClick: _ctx.goToHistory,
          class: "points-card_action"
        }, {
          default: _withCtx(() => [
            _hoisted_10,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('history')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      (_ctx.isNotEnoughPoints)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$t('pointsPage.spendPointsTip', { count: _ctx.countPointsToDebit })), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}